// extracted by mini-css-extract-plugin
export default {"responsiveVideo":"GiphyMedia-responsiveVideo-f63c29f182e2405065ada1cee543d23c","responsiveContainer":"GiphyMedia-responsiveContainer-0125ea8029f0f6c0a353370490b23e59"};